module.exports = __webpack_public_path__ + "dcc09fd35fda9d4447834dae7a620e67.png";